import http from "../http-common";

class TokenService {

    getTokenB() {
        return http.post("/token");
    }
}

export default new TokenService();